<template>
    <modal class="selectItemModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">{{title}}<span class="close iconfont icon-a-bg-close3x" @click="hide()"></span></div>
        <div class="modal-body">
            <div class="list-box">
                <div class="item-box" :class="{selected:selectItem?.Food_ID==item.Food_ID}"
                    @click="change(item)"
                    v-for="item in data" :key="item">
                    <i class="iconfont" :class="selectItem?.Food_ID==item.Food_ID?'icon-danxuanxiangxuanzhong':'icon-a-danxuanweixuanzhong'"></i>
                    <div class="name nowrap2">{{item.Food_Name}}</div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close","change"],
    name:"selectItemModel",
    props:{
        /**标题 */
        title:{
            type:String,
            default:'请选择套餐'
        },
        isShow:{
            type:Boolean,
            default:false,
        },
        /**菜品数据 */
        data:{
            type:Array,
            default:null
        },
        /**默认选中值 */
        defaultVal:{
            type:Object,
            default:null
        }
    },
    data(){
        return {
            /**选中的菜 */
            selectItem:null
        }
    },
    watch:{
        defaultVal:{
            handler(newVal){
                this.selectItem=newVal;
            },
            immediate:true
        }
    },
    mounted(){

    },
    methods:{
        //关闭
        hide(){
            this.$emit('close')
        },
        change(item){
            this.selectItem=item;
            this.$emit('change',item);
        }
    }
}
</script>

<style lang="sass">
@import "./selectItemModel.scss";
</style>